import * as actionTypes from './actionTypes';

export const togglePriceGap=()=>({
    type:actionTypes.TOGGLE_PRICE_GAP_UPDATE
});